// extracted by mini-css-extract-plugin
module.exports = {"root":"NoListingsFallback_root__O2qYA"};